<p *ngIf="askForDevelopmentArea" class="material-form-field-wrapper" fxLayout="row" fxLayoutGap="16px">
  <label id="newDevArea">Befindet sich Ihr Objekt in einem Neubaugebiet?</label>
  <mat-radio-group
    aria-label="Objekt ist in einem Neubaugebiet"
    [(ngModel)]="isNewDevelopmentArea"
    [disabled]="disable"
    (change)="resetGisData()">
    <mat-radio-button [value]="true" [disabled]="disable">Ja</mat-radio-button>
    <mat-radio-button [value]="false" [disabled]="disable">Nein</mat-radio-button>
  </mat-radio-group>
</p>

<form [formGroup]="connectionObjectForm">
  <!-- Objekt befindet sich nicht in einem Neubaugebiet -->
  <div *ngIf="!isNewDevelopmentArea">
    <!-- Eingabefeld für Ort -->
    <mat-form-field appearance="outline" class="search-field" *ngIf="!streetNoSelected">
      <mat-label>
        {{ ('noConnectionObjectPostalCode' | uiAdaptionVisible) ? 'Ortsteil / Ort' : 'Postleitzahl / Ort' }}
      </mat-label>
      <input
        type="text"
        matInput
        formControlName="zipCodeCity"
        [matAutocomplete]="autoCityZipCode"
        appAdaptionSuppressAutocomplete />
      <mat-autocomplete #autoCityZipCode="matAutocomplete">
        <div class="select-elements">folgende Orte wurden gefunden. Bitte auswählen.</div>
        <mat-option
          *ngFor="let option of cityOptions"
          [value]="option.zipCode + ' / ' + option.city"
          (onSelectionChange)="
            $event.source.selected == true && selectedOption(option, gisFieldsEnum.zipCode)
          ">
          {{ option.zipCode + ' ' + option.city }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Fehlermeldung wenn Ort nicht gefunden wurde -->
    <div class="not-found" *ngIf="cityOptions?.length == 0 && !disable">
      Der von Ihnen eingegebene Ort befindet sich leider ausserhalb unseres Versorgungsgebiets. Sie können
      sich auf
      <a target="_blank" href="https://www.vnbdigital.de/">VNBdigital</a>
      über Ihren zuständigen Netzbetreiber erkundigen.
    </div>

    <!-- Eingabefeld für Straße -->
    <mat-form-field appearance="outline" class="search-field" *ngIf="!streetNoSelected">
      <mat-label>Straße:</mat-label>
      <input
        type="text"
        matInput
        formControlName="street"
        [matAutocomplete]="autoStreet"
        appAdaptionSuppressAutocomplete />
      <mat-autocomplete #autoStreet="matAutocomplete">
        <div *ngIf="streetOptions?.length > 0" class="select-elements">
          Folgende Straßen wurden gefunden. Bitte auswählen.
        </div>
        <mat-option
          *ngFor="let option of streetOptions"
          [value]="option.street"
          (onSelectionChange)="
            $event.source.selected == true && selectedOption(option, gisFieldsEnum.street)
          ">
          {{ option.street }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Fehlermeldung wenn Straße nicht gefunden wurde -->
    <div class="not-found" *ngIf="streetOptions?.length == 0">
      Wir konnten die von Ihnen eingegebene Straße nicht finden. Wenn Sie sich in einem Neubaugebiet befinden,
      wählen Sie dies aus. Sie können dann eine Flurstücksnummer angeben.
    </div>

    <!-- Checkbox mit der Beschreibung "Keine Hausnummer vorhanden, Stattdessen Flurstücksnummer angeben" -->
    <div *ngIf="!streetNoSelected && streetSelected">
      <mat-checkbox
        [disabled]="disable || disableCorridorCheck"
        [checked]="isNoHouseNumber"
        (change)="isNoHouseNumber = !isNoHouseNumber; resetHouseNoFormState()">
        Keine Hausnummer vorhanden, Stattdessen Flurstücksnummer angeben.
      </mat-checkbox>
    </div>

    <!-- Eingabefeld für Hausnummer -->
    <div *ngIf="!streetNoSelected && streetSelected">
      <div *ngIf="!isNoHouseNumber">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Hausnummer</mat-label>
          <input
            type="text"
            matInput
            formControlName="streetNo"
            [matAutocomplete]="autoStreetNo"
            #streetNoTrigger2="matAutocompleteTrigger"
            appAdaptionSuppressAutocomplete />
          <mat-spinner *ngIf="isSearching" matSuffix [diameter]="20"></mat-spinner>
          <mat-hint *ngIf="isSearching">Verfügbarkeit wird geprüft…</mat-hint>
          <div *ngIf="streetNoOptions?.length == 0">No records found.</div>
          <mat-autocomplete #autoStreetNo="matAutocomplete" (closed)="closedStreetNoSelectWithoutSelection()">
            <div *ngIf="streetNoOptions?.length > 0">
              <div *ngIf="isNotFound" class="not-found">
                Wir konnten die von Ihnen eingegebene Hausnummer nicht finden. Sie können trotzdem fortfahren
                und Ihren Hausanschluss beantragen
              </div>
              <div *ngIf="!isNotFound" class="select-elements">
                Folgende Nummern wurden gefunden. Bitte auswählen.
              </div>
            </div>
            <mat-option
              *ngFor="let option of streetNoOptions"
              [value]="option.houseNo"
              (onSelectionChange)="
                $event.source.selected == true && selectedOption(option, gisFieldsEnum.streetNo); saveData()
              ">
              <span *ngIf="option.id == fakeIdStreetNumberNotFound">Klicken um mit der Hausnummer</span>
              {{ option.houseNo }}
              {{ option.houseNoAddition ? option.houseNoAddition : '' }}
              <span *ngIf="option.id == fakeIdStreetNumberNotFound">fortzufahren</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div *ngIf="isNoHouseNumber">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Flurstücksnummer</mat-label>
          <input
            type="text"
            matInput
            formControlName="corridorNumber"
            (blur)="corridorNumberSelected()"
            appAdaptionSuppressAutocomplete />
        </mat-form-field>
      </div>
    </div>

    <!-- Zusammenfassung der eingegeben Adresse nach auswahl der Hausnummer -->
    <div *ngIf="streetNoSelected">
      <h4>Adresse:</h4>
      {{ zipCodeCityReadable }}
      <br />
      {{ streetField.value }} {{ streetNoField.value }}{{ streetNoAdditionField.value }}
      <span *ngIf="corridorNumberField.value">Flurstücksnummer:</span>
      {{ corridorNumberField.value }}

      <!-- Button zum zurücksetzen der Adresse -->
      <mat-icon *ngIf="!disable" (click)="resetGisData()" style="cursor: pointer" matSuffix>
        mode_edit
      </mat-icon>
    </div>

    <!-- Fehlermeldung wenn keine Option ausgewählt wurde -->
    <div style="float: left; width: 100%" *ngIf="showSelectMessage">
      <div class="alert alert-danger">Bitte wählen Sie eine Option aus.</div>
    </div>

    <div class="not-found" *ngIf="!areaAvailable">
      Für die von Ihnen eingegebene Adresse ist die angefragte Sparte nicht verfügbar.
    </div>
  </div>

  <!-- Objekt befindet sich in einem Neubaugebiet -->
  <div *ngIf="isNewDevelopmentArea">
    <mat-form-field appearance="outline" class="search-field">
      <ng-container *ngIf="'noConnectionObjectPostalCode' | uiAdaptionValue; else showPostalCode">
        <mat-label>Ort / Ortsteil</mat-label>
      </ng-container>
      <ng-template #showPostalCode><mat-label>Postleitzahl / Ort</mat-label></ng-template>
      <input
        type="text"
        matInput
        formControlName="zipCodeCity"
        [matAutocomplete]="autoCityZipCode"
        appAdaptionSuppressAutocomplete />
      <mat-autocomplete #autoCityZipCode="matAutocomplete">
        <div class="select-elements">folgende Orte wurden gefunden. Bitte auswählen.</div>
        <mat-option
          *ngFor="let option of cityOptions"
          [value]="option.zipCode + ' / ' + option.city"
          (onSelectionChange)="
            $event.source.selected == true && selectedOption(option, gisFieldsEnum.zipCode)
          ">
          {{ option.zipCode + ' ' + option.city }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div class="not-found" *ngIf="cityOptions?.length == 0 && !disable">
      Der von Ihnen eingegebene Ort befindet sich leider ausserhalb unseres Versorgungsgebiets. Sie können
      sich auf
      <a target="_blank" href="https://www.vnbdigital.de/">VNBdigital</a>
      über Ihren zuständigen Netzbetreiber erkundigen.
    </div>
    <div class="not-found" *ngIf="(developmentAreasByZipCode$ | async)?.length == 0">
      Wenn Sie bereits einen Straßennamen haben, ist ihr Neubaugebiet bei uns vielleicht nicht mehr geführt,
      probieren Sie es dann bitte mit Ihrer normalen Adresse.
    </div>
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Name Neubaugebiet</mat-label>
      <input
        type="text"
        matInput
        formControlName="developmentAreaName"
        appAdaptionSuppressAutocomplete
        [matAutocomplete]="autoCityZipCodeNewArea" />
      <span matTextSuffix *ngIf="developmentAreaStreetName$ | async as streetName">{{ streetName }}</span>
      <mat-autocomplete #autoCityZipCodeNewArea="matAutocomplete">
        <div class="select-elements">folgende Orte wurden gefunden. Bitte auswählen.</div>
        <div>
          <mat-option
            *ngFor="let option of developmentAreasByZipCode$ | async"
            [value]="option.name"
            (onSelectionChange)="
              $event.source.selected == true && selectedOption(option, gisFieldsEnum.developmentArea)
            ">
            {{ option.name + (option.defaultStreetName ? ' - ' + option.defaultStreetName : '') }}
          </mat-option>
        </div>
      </mat-autocomplete>
    </mat-form-field>
    <div>
      <div>
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Flurstücksnummer</mat-label>
          <input
            type="text"
            matInput
            formControlName="corridorNumber"
            maxlength="10"
            appAdaptionSuppressAutocomplete />
        </mat-form-field>
      </div>
    </div>
    <mat-progress-bar *ngIf="isSearching" style="margin-top: -22px" mode="indeterminate"></mat-progress-bar>
  </div>
</form>
